import React, { useEffect, useRef, useState } from "react";

/**
 * BlobCursor — soft glowing gradient blob that follows the mouse.
 * Activates only on devices with hover (desktops).
 */
const BlobCursor = () => {
  const ref = useRef(null);
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    const canHover = window.matchMedia("(hover: hover)").matches;
    if (!canHover) {
      setHidden(true);
      return;
    }

    let raf = null;
    let pos = { x: window.innerWidth / 2, y: window.innerHeight / 2 };
    let target = { ...pos };

    const onMove = (e) => {
      target.x = e.clientX;
      target.y = e.clientY;
      if (!raf) raf = requestAnimationFrame(loop);
    };

    const loop = () => {
      pos.x += (target.x - pos.x) * 0.12;
      pos.y += (target.y - pos.y) * 0.12;
      if (ref.current) {
        ref.current.style.transform = `translate3d(${pos.x - 200}px, ${pos.y - 200}px, 0)`;
      }
      if (Math.abs(target.x - pos.x) > 0.5 || Math.abs(target.y - pos.y) > 0.5) {
        raf = requestAnimationFrame(loop);
      } else {
        raf = null;
      }
    };

    window.addEventListener("mousemove", onMove);
    return () => {
      window.removeEventListener("mousemove", onMove);
      if (raf) cancelAnimationFrame(raf);
    };
  }, []);

  if (hidden) return null;

  return (
    <div
      ref={ref}
      aria-hidden="true"
      className="pointer-events-none fixed top-0 left-0 z-[2] w-[400px] h-[400px] rounded-full opacity-40 mix-blend-screen"
      style={{
        background:
          "radial-gradient(circle, rgba(168,85,247,0.55) 0%, rgba(236,72,153,0.25) 35%, rgba(10,10,26,0) 60%)",
        filter: "blur(40px)",
        willChange: "transform",
      }}
    />
  );
};

export default BlobCursor;
